    <template>
        <div class="card card-custom gutter-b" v-loading="loading">
            <div class="card-header d-flex justify-content-between">
            <div class="card-title">
                <h3 class="card-label">Quản lý công demo</h3>
            </div>
            <div class="card-title">
                <div class="dropdown dropdown-inline mr-2">
                    <button type="button" @click="exportCongDemo" class="btn btn-warning font-weight-bolder mr-6">
                        <i class="fa far fa-cloud-download p-0 mr-2"></i> Tải Công Demo
                    </button>
                    <button type="button" @click="exportAttendance" class="btn btn-success font-weight-bolder mr-6">
                        <i class="fa far fa-file-import p-0 mr-2"></i> Import Công Demo
                    </button>
                    <button type="button" @click="exportOption" class="btn btn-light-primary font-weight-bolder">
                        <i class="fa far fa-add p-0 mr-2"></i> Thêm mới công demo
                    </button>

                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="example mb-10">
                <div class="row">
                    <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
                        <el-select v-model="query.center_ids" multiple filterable collapse-tags
                                   placeholder="Chọn trung tâm"
                                   @change="changeCenter">
                            <el-option v-for="item in centers" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
                        <el-select v-model="query.branch_ids" multiple filterable collapse-tags
                                   placeholder="Chọn chi nhánh"
                                   @change="changeBranch">
                            <el-option v-for="item in branches" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
                        <el-select v-model="query.class_ids" multiple filterable collapse-tags
                                   placeholder="Chọn lớp học">
                            <el-option v-for="item in class_ids" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
                        <el-select v-model="query.group_id" clearable filterable collapse-tags
                                   placeholder="Chọn nhóm giảng viên"
                                   @change="changeTeacher">
                            <el-option v-for="item in listTeacherGroup" :key="item.id" :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
                        <el-select v-model="query.teacher_ids" multiple filterable collapse-tags
                                   placeholder="Chọn tên giảng viên"
                                   @change="changeTeacher">
                            <el-option v-for="item in teachers" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="col-sm-12	col-md-6	col-lg-4	col-xl-2 mt-5">
                        <button class=" btn btn-primary font-weight-bold mr-2"
                                @click="searchData">
                            <i class="fa fa-search"></i> Tìm kiếm
                        </button>
                    </div>
                </div>
                <div class="example-preview table-responsive overflow-auto mt-3">
                    <table class="table table-hover table-bordered table-vertical-center b-table"
                           style="text-align: center">
                        <thead>
                        <tr>
                            <th scope="col" class="min-w-100px">Tên GV - Mã GV</th>
                            <th scope="col" class="min-w-100px">Ngày học-Thời Gian</th>
                            <th scope="col" class="min-w-100px">Cở sở dạy</th>
                            <th scope="col" class="min-w-100px">Đơn giá</th>
                        </tr>
                        </thead>
                        <tbody>
                        <ClassTimesheetItem v-for="item in classErrorList"
                            @getApi-class="getApiClass" :classError="item"
                            :key="item.id">
                        </ClassTimesheetItem>
                        <tr v-if="classErrorList.length === 0 && !loading">
                            <td colspan="9" class="event-title no-data">Chưa có dữ liệu</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="position-absolute" style="right:40px">
                    Tổng số bản ghi: <b style="color:#3699FF">{{ total }}</b>
                </div>
            </div>
        </div>
        <div class="edu-paginate mx-auto text-center">
            <paginate v-model="page" :page-count="last_page" :page-range="3" :margin-pages="1"
                      :click-handler="clickCallback"
                      :prev-text="'Trước'" :next-text="'Sau'" :container-class="'pagination b-pagination'"
                      :pageLinkClass="'page-link'" :next-link-class="'next-link-item'"
                      :prev-link-class="'prev-link-item'"
                      :prev-class="'page-link'" :next-class="'page-link'" :page-class="'page-item'">
            </paginate>
        </div>

        <!--  Modal Export Option -->
        <el-dialog v-if="is_dialog_option" :show-close="false" :visible.sync="is_dialog_option" width="30%">
            <div slot="title" style="display: flex; width: 100%; justify-content: space-between">
                <h3>Export dữ liệu</h3>
                <i class="el-icon-close" style="cursor: pointer" @click="closeDialog"></i>
            </div>
            <div v-if="!isCertificate">
                <strong>Vui lòng chọn dữ liệu để tải xuống</strong>
                <div class="d-flex flex-column mt-5">
                    <el-radio v-model="type_export" :label="1">Danh sách học viên</el-radio>
                    <el-radio class="mt-2" v-model="type_export" :label="2">Danh sách lượt học</el-radio>
                    <el-radio class="mt-2" v-model="type_export" :label="3">Bằng khen, chứng chỉ</el-radio>
                </div>
                <div slot="footer" class="dialog-footer d-flex justify-content-end">
                    <el-button @click="is_dialog_option = false"
                               style="background: #E6E6E6 !important; color: #0a0a0a !important;">
                        Hủy
                    </el-button>
                    <el-button :disabled="is_disable_export"
                               style="background: #4c0192 !important; color: white !important;" @click="exportData">
                        <i v-if="is_disable_export" class="el-icon-loading mr-2"></i>
                        <i v-else class="el-icon-download mr-2"></i>Export
                    </el-button>
                </div>
            </div>
            <DialogConfirmExportCertificate :payload="query" @closeDialog="closeDialog" v-else/>
        </el-dialog>
        <!--  Modal Export Option -->
        <el-dialog v-if="is_dialog_attendance" :show-close="false" :visible.sync="is_dialog_attendance" :width="hasErrors ? '50%' : '30%'">
            <div slot="title" style="display: flex; width: 100%; justify-content: space-between">
                <h3>{{ listErrors.length > 0 ? 'Xem trước khi import công trừ' : 'Công trừ giáo viên'  }}</h3>
                <i class="el-icon-close" style="cursor: pointer" @click="closeDialog"></i>
            </div>
            <div class="mb-2">
                <TableImportErrorGlobal :columns="columns" v-if="hasErrors" :response-error="listErrors"/>
                <div >
                    <p >Bước 1: Tải file mẫu</p>
                    <div>
                        <el-button :loading="download_default" class="btn btn-primary " size="small" @click="exportFileMau">
                            <i class="el-icon-download text--white"></i>
                            <span class="text--white">Tải xuống</span>
                        </el-button>
                    </div>
                </div>
            </div>
            <div >
                <div class="mt-6">
                    <p >Bước 2: Tải file excel lên hệ thống</p>
                    <div class="mb-2">
                        <el-upload
                            ref="upload"
                            accept=".xlsx"
                            :limit="1"
                            list-type="text"
                            action=""
                            :file-list="fileList"
                            :on-change="handleChange"
                            :on-remove="handleRemove"
                            :auto-upload="false"
                            :multiple="false"
                        >
                            <el-button class="btn btn-warning " size="small">
                                <i class="el-icon-upload2 text--white"></i>
                                <span class="text--white">Tải lên</span>
                            </el-button>
                        </el-upload>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelImport">Hủy</el-button>
                <el-button :disabled="disableImport || disabledSubmit()" :loading="loading" type="success" class="btn btn-success"
                           @click="checkImport ? handleImportFileExcel() : handlePreviewImportFileExcel()"> {{ checkImport ? 'Import ' : 'Kiểm tra data'}}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>

import {SET_BREADCRUMB} from "../../../core/services/store/breadcrumbs.module";
import ClassTimesheetItem from "./components/ClassTimesheetItem.vue";
import {GET_CENTERS} from "../../../core/services/store/center/centers.module";
import {GET_BRANCHES} from "../../../core/services/store/center/branch.module";
import {
    EXPORT_ERROR_CLASSROOM,
    GET_TEACHERS_OR_TUTORS,
    EXPORT_ERROR_CLASSROOM_STUDENT,
    CLASS_ERROR_LIST,
    CLASS_FILTER,
    EXPORT_FILE_DEFAULT_DEDUCTION,
    PREVIEW_IMPORT_DEDUCTION,
    IMPORT_DEDUCTION,
    CLASS_TIMESHEETS,
    EXPORT_FILE_DEFAULT_CLASS_TIMESHEETS,
    PREVIEW_IMPORT_CLASS_TIMESHEETS,
    IMPORT_CLASS_TIMESHEETS,
    EXPORT_CLASS_TIMESHEETS
} from "../../../core/services/store/course/classes.module";
import {GET_COURSES_LIST} from "../../../core/services/store/course/course.module";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import {
    exportExcel,
    HEADER_ROW_EXPORT_ERROR_LIST_STUDY_TURN,
    HEADER_ROW_EXPORT_ERROR_LIST_STUDENT
} from "../../../core/filters";
import DialogConfirmExportCertificate from "./components/DialogConfirmExportCertificate.vue";
import {GET_TEACHER_GROUPS} from "@/core/services/store/teacher/teacher.module";
import * as XLSX from "xlsx";
import TableImportError from "../tax-invoice/components/TableImportError.vue";
import TableImportErrorGlobal from "./TableImportErrorGlobal.vue";


export default {
    components: {
        TableImportErrorGlobal,
        TableImportError,
        DialogConfirmExportCertificate,
        ClassTimesheetItem,
        DatePicker
    },

    name: "manageClass",
    data() {
        return {
            query: {
                center_ids: [],
                branch_ids: [],
                course_ids: [],
                class_name: '',
                teacher_ids: [],
                class_ids: [],
                date_range: [],
                group_id: ''
            },
            columns: {
                'date': 'Ngày',
                'ma_giao_vien': 'Mã GV',
                'thoi_gian_bat_dau': 'Thời gian bắt đầu',
                'thoi_gian_ket_thuc': 'Thời gian kết thúc',
                'don_gia': 'Đơn giá',
                'ma_co_so_day': 'Mã Cơ sở dạy',
                'errors': 'Status'
            },
            fileList: [],
            uploading: false,
            disable: false,
            checkImport: false,
            progress: 0,
            listCertificate: [],
            oneClassList: {},
            classErrorList: [],
            centers: [],
            center_ids: [],
            branches: [],
            teachers: [],
            courses: [],
            class_ids: [],
            is_disable_search: false,
            last_page: 1,
            page: 1,
            total: 0,
            is_disable_export: false,
            is_dialog_option: false,
            is_dialog_attendance: false,
            type_export: 1,
            loading: true,
            isCertificate: false,
            download_default: false,
            listTeacherGroup: [],
            fileImport: null,
            disableImport: true,
            listErrors: [],
            startImport: true,
        };
    },

    async mounted() {
        await this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Quản lý công demo"},
            {title: "Quản lý dạy học"},
        ]);
        await this.getCenters();
        this.getBranches();
        this.getTeachers();
        this.callApiGetList();
        this.getTeacherGroups();
    },
    computed: {
        hasErrors() {
            return this.listErrors && this.listErrors.length > 0;
        },
    },

    methods: {
        changeCenter() {
            this.getClasses();
        },
        changeBranch() {
            this.getClasses();
            this.callApiGetList();
        },
        changeTeacher() {
            this.getClasses();
            this.callApiGetList();
        },
        exportOption() {
            this.is_dialog_option = true;
        },
        exportAttendance() {
            this.is_dialog_attendance = true;
        },
        exportData() {
            this.is_disable_export = true;
            switch (this.type_export) {
                case 1:
                    this.exportStudentList();
                    break
                case 2:
                    this.exportStudySession();
                    break;
                case 3:
                    this.isCertificate = true;
                    break
                default:
                    return;
            }
        },
        closeDialog() {
            this.is_dialog_option = false
            this.is_dialog_attendance = false
            this.isCertificate = false
            this.is_disable_export = false
            this.type_export = 1
        },
        async exportStudentList() {
            let data_student;
            await this.$store.dispatch(EXPORT_ERROR_CLASSROOM_STUDENT, {
                ...this.query,
            }).then((res) => {
                data_student = res.data;
            }).finally(() => {
                this.is_disable_export = false;
                this.is_dialog_option = false;
            });
            exportExcel(HEADER_ROW_EXPORT_ERROR_LIST_STUDENT, data_student, "Danh sách học viên.xlsx", false)
        },
        async exportStudySession() {
            let data_study;
            await this.$store.dispatch(EXPORT_ERROR_CLASSROOM, {
                ...this.query,
            }).then((res) => {
                data_study = res.data;
            }).finally(() => {
                this.is_disable_export = false;
                this.is_dialog_option = false;
            });
            exportExcel(HEADER_ROW_EXPORT_ERROR_LIST_STUDY_TURN, data_study, "Danh sách lượt học.xlsx", false)
        },
        clickCallback(obj) {
            this.page = obj
            this.$router.push({
                name: 'manage-error',
                query: {
                    page: this.page,
                    ...this.query
                }
            })
            this.callApiGetList()
        },
        pushParamsUrl() {
            this.$router.push({
                name: 'class-timesheets',
                query: {
                    page: this.page,
                    ...this.query
                }
            })
        },
        searchData() {
            this.page = 1
            this.is_disable_search = true
            this.pushParamsUrl()
            this.callApiGetList()
        },
        callApiGetList() {
            let payload = {};
            payload = {...this.query, page: this.page}
            if (payload.center_ids.length == 0) {
                payload = {...payload, center_ids: this.center_ids}
            }
            this.$store.dispatch(CLASS_TIMESHEETS, payload).then((res) => {
                if (!res.error) {
                    this.loading = false
                    this.classErrorList = res.data?.data ?? res.data;
                    this.last_page = res.last_page ?? res.pagination.last_page;
                    this.total = res.total ?? res.pagination.total;
                    this.is_disable_search = false;
                }
            });
        },
        async getClasses() {
            this.query.class_ids = [];
            let payload = {};
            payload = {...this.query, page: this.page}
            if (payload.center_ids.length == 0) {
                payload = {...payload, center_ids: this.center_ids}
            }
            await this.$store.dispatch(CLASS_TIMESHEETS, payload).then((res) => {
                if (!res.error) {
                    this.class_ids = res.data;
                }
            });
        },
        getApiClass(nameClass) {
            this.oneClassList = this.classList[0];
        },

        // lấy API tất cả các trung tâm
        getCenters() {
            return this.$store.dispatch(GET_CENTERS, {is_edutalk: '1'}).then((res) => {
                if (!res.error) {
                    for (let dataKey in res.data.data) {
                        this.center_ids.push(res.data.data[dataKey].id);
                        this.centers.push({
                            id: res.data.data[dataKey].id,
                            name: res.data.data[dataKey].name,
                        });
                    }
                }
            });
        },

        // lấy API tất cả các giảng viên
        getTeachers() {
            return this.$store
                .dispatch(GET_TEACHERS_OR_TUTORS, {
                    limit: 10000,
                    is_teacher: 1,
                    center_ids: this.query.center_ids.length > 0 ? this.query.center_ids : this.center_ids
                })
                .then((res) => {
                    if (!res.error) {
                        this.teachers = res.data;
                    }
                })
                .catch((e) => {
                    console.log(e, "error");
                });
        },

        // lấy API tất cả các chi nhánh
        getBranches() {
            return this.$store
                .dispatch(GET_BRANCHES, {
                    limit: 10000,
                    status: 1,
                    center_ids: this.query.center_ids.length > 0 ? this.query.center_ids : this.center_ids
                })
                .then((res) => {
                    if (!res.error) {
                        this.branches = res.data.data;
                    }
                });
        },

        // lấy API tất cả các khoá học
        getCourses() {
            return this.$store
                .dispatch(GET_COURSES_LIST, {
                    limit: 10000,
                    status: 1,
                    center_ids: this.query.center_ids.length > 0 ? this.query.center_ids : this.center_ids
                })
                .then((res) => {
                    if (!res.error) {
                        this.courses = res.data;
                        // this.setCacheTheLoad()
                    }
                })
                .catch((e) => {
                    console.log(e, "error");
                });
        },
        getTeacherGroups() {
            this.$store.dispatch(GET_TEACHER_GROUPS).then((data) => {
                this.listTeacherGroup = data.data
                this.listTeacherGroup.splice(0, 0, {id: 0, name: '(Không có nhóm)'})
            })
        },
        handleChange(file, fileList) {
            this.fileList = fileList
            this.fileImport = file.raw;
            this.disableImport = false;
            this.parseExcel(this.fileImport);
        },
        parseExcel(file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const workbook = XLSX.read(new Uint8Array(e.target.result), {type: "array"});
                const sheet = workbook.Sheets[workbook.SheetNames[0]];
                const rawData = XLSX.utils.sheet_to_json(sheet, { header: 1, cellDates: true, raw: false });
                const formattedData = rawData.map(row =>
                    row.map(cell => cell instanceof Date
                        ? cell.toISOString().split('T')[0]  // yyyy-mm-dd
                        : cell
                    )
                );
                const [headers, ...rows] = formattedData;
                const columnMap = {
                    "Ngày": "ngay",
                    "ID Lớp": "ma_lop",
                    "Lớp": "ten_lop",
                    "Lý do": "ly_do",
                    "Mã giáo viên": "ma_giao_vien",
                    "Số công trừ": "so_cong_tru",
                    "Lịch học": "schedule_id",
                };
                const mappedHeaders = headers.map(h => columnMap[h] || h);
                this.dataImport = rows
                    .filter(row => row.length > 0)
                    .map(row => {
                        const item = {};
                        mappedHeaders.forEach((key, i) => item[key] = row[i]);
                        return {...item, error: []};
                    });
            };

            reader.readAsArrayBuffer(file);
        },
        handleRemove() {
            this.fileList = []
            this.listErrors = [];
            this.checkImport = false;
            this.disableImport = true;
            this.startImport = true;
        },
        cancelImport() {
            this.fileList = []
            this.is_dialog_attendance = false;
            this.fileImport = null;
            this.listErrors = [];
            this.startImport = true;
            this.checkImport = false;
            this.disableImport = true;
        },
        exportFileMau() {
            this.download_default  = true
            this.$store.dispatch(EXPORT_FILE_DEFAULT_CLASS_TIMESHEETS).then((res) => {
                this.download_default = false
                this.$notify({
                    title: 'Thành công',
                    message: res.message,
                    type: 'success'
                })
            }).catch((error) => {
                this.download_default = false
                this.$notify({
                    title: 'Thất bại',
                    message: error.data.message,
                    type: 'error'
                })
            })
        },
        exportCongDemo() {
            this.download_default  = true
            this.$store.dispatch(EXPORT_CLASS_TIMESHEETS).then((res) => {
                this.download_default = false
                this.$notify({
                    title: 'Thành công',
                    message: res.message,
                    type: 'success'
                })
            }).catch((error) => {
                this.download_default = false
                this.$notify({
                    title: 'Thất bại',
                    message: error.data.message,
                    type: 'error'
                })
            })
        },
        async handlePreviewImportFileExcel() {
            this.disableImport = true;
            this.loading = true;
            if (!this.fileImport) {
                this.$notify({title: "Thất bại", message: "Chưa có file nào được chọn", type: "error"});
                this.disableImport = false;
                this.loading = false;
                return;
            }
            if (this.dataImport.length === 0) {
                this.$message.warning("Bạn không thể import khi file excel không có bản ghi nào");
                this.disableImport = false;
                this.loading = false;
                return;
            }
            try {
                const res = await this.$store.dispatch(PREVIEW_IMPORT_CLASS_TIMESHEETS, this.dataImport);
                const rawErrors = res?.data?.dataImport || [];
                this.checkImport = res.data?.checkImport;
                this.dataImport = rawErrors;
                this.isBack = true;
                this.loading = false;
                this.listErrors = rawErrors.map(item => ({
                    date: item.date,
                    ma_giao_vien: item.ma_giao_vien,
                    ten_giao_vien: item.ten_giao_vien,
                    thoi_gian_bat_dau: item.thoi_gian_bat_dau,
                    thoi_gian_ket_thuc: item.thoi_gian_ket_thuc,
                    don_gia: item.don_gia,
                    ma_co_so_day: item.ma_co_so_day,
                    ten_co_so_day: item.ten_co_so_day,
                    errors: item.error || []
                }));
            } catch (error) {
                this.$message.error("Import thất bại");
            } finally {
                this.disabledSubmit()
                this.disableImport = false;
                this.loading = false;
            }
        },
        disabledSubmit() {
            return this.listErrors.filter(item => item.errors.length > 0).length > 0
        },
        async handleImportFileExcel() {
            this.loading = true;
            try {
                const res = await this.$store.dispatch(IMPORT_CLASS_TIMESHEETS, this.dataImport);
                if (!res.error) {
                    this.$message.success("Import thành công");
                }
            } catch (e) {
                this.$message.error("Import thất bại");
            } finally {
                this.loading = false;
                this.closeDialog();
            }
        }
    },
};
</script>
<style lang="scss" scoped></style>
